import React, { useState, useEffect, useCallback } from 'react';
import { supabase } from '../../lib/supabase';
import { Mail, Trash2, Eye, EyeOff } from 'lucide-react';

const MessagesAdmin = () => {
  const [messages, setMessages] = useState([]);
  const [selected, setSelected] = useState(null);

  const fetch = useCallback(async () => {
    const { data } = await supabase.from('contact_messages').select('*').order('created_at', { ascending: false });
    setMessages(data || []);
  }, []);
  useEffect(() => { fetch(); }, [fetch]);

  const toggleRead = async (msg) => {
    await supabase.from('contact_messages').update({ is_read: !msg.is_read }).eq('id', msg.id);
    fetch();
  };

  const remove = async (id) => {
    if (!window.confirm('Remover esta mensagem?')) return;
    await supabase.from('contact_messages').delete().eq('id', id);
    if (selected?.id === id) setSelected(null);
    fetch();
  };

  const markAsRead = async (msg) => {
    if (!msg.is_read) {
      await supabase.from('contact_messages').update({ is_read: true }).eq('id', msg.id);
      fetch();
    }
    setSelected(msg);
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white">Mensagens</h1>
        <span className="text-gray-400 text-sm">{messages.filter(m => !m.is_read).length} não lidas</span>
      </div>
      <div className="grid lg:grid-cols-2 gap-6">
        <div className="space-y-2 max-h-[70vh] overflow-auto">
          {messages.length === 0 && <p className="text-gray-500 text-center py-8">Nenhuma mensagem</p>}
          {messages.map(msg => (
            <div key={msg.id} onClick={() => markAsRead(msg)}
              className={`bg-gray-900 border rounded-xl p-4 cursor-pointer transition-colors ${selected?.id === msg.id ? 'border-lime-400' : msg.is_read ? 'border-gray-800' : 'border-lime-400/30 bg-gray-900/80'}`}>
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center space-x-2">
                  {!msg.is_read && <div className="w-2 h-2 bg-lime-400 rounded-full"></div>}
                  <p className={`font-semibold text-sm ${msg.is_read ? 'text-gray-300' : 'text-white'}`}>{msg.name}</p>
                </div>
                <span className="text-gray-500 text-xs">{new Date(msg.created_at).toLocaleDateString('pt-BR')}</span>
              </div>
              <p className="text-gray-400 text-xs">{msg.email}</p>
              <p className="text-gray-500 text-xs mt-1 truncate">{msg.message}</p>
            </div>
          ))}
        </div>
        <div>
          {selected ? (
            <div className="bg-gray-900 border border-gray-800 rounded-2xl p-6 sticky top-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-bold text-white">{selected.name}</h3>
                <div className="flex items-center space-x-2">
                  <button onClick={() => toggleRead(selected)} className="p-2 text-gray-400 hover:text-lime-400" title={selected.is_read ? 'Marcar como não lida' : 'Marcar como lida'}>
                    {selected.is_read ? <EyeOff size={16} /> : <Eye size={16} />}
                  </button>
                  <button onClick={() => remove(selected.id)} className="p-2 text-gray-400 hover:text-red-400"><Trash2 size={16} /></button>
                </div>
              </div>
              <div className="space-y-3 mb-6">
                <div className="flex items-center space-x-2"><Mail size={14} className="text-gray-500" /><a href={`mailto:${selected.email}`} className="text-lime-400 text-sm hover:underline">{selected.email}</a></div>
                {selected.company && <p className="text-gray-400 text-sm">Empresa: {selected.company}</p>}
                <p className="text-gray-500 text-xs">Idioma: {selected.language} | {new Date(selected.created_at).toLocaleString('pt-BR')}</p>
              </div>
              <div className="bg-gray-800 rounded-xl p-4 border border-gray-700">
                <p className="text-gray-300 text-sm leading-relaxed whitespace-pre-wrap">{selected.message}</p>
              </div>
              <a href={`mailto:${selected.email}?subject=Re: Portfolio Contact`} className="mt-4 inline-flex items-center space-x-2 px-6 py-2 bg-lime-400 text-black font-bold rounded-full hover:bg-lime-300 text-sm">
                <Mail size={16} /><span>Responder</span>
              </a>
            </div>
          ) : (
            <div className="bg-gray-900 border border-gray-800 rounded-2xl p-12 text-center">
              <Mail className="text-gray-600 mx-auto mb-4" size={48} />
              <p className="text-gray-500">Selecione uma mensagem para ler</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MessagesAdmin;
